var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11629 1.60942C4.98403 1.60942 1.61792 4.97552 1.61792 9.10781C1.61792 13.2401 4.98403 16.6127 9.11629 16.6127C10.8813 16.6127 12.5046 15.9942 13.7875 14.9672L16.9109 18.0889C17.0685 18.24 17.279 18.3234 17.4974 18.3211C17.7157 18.3189 17.9245 18.2313 18.079 18.077C18.2335 17.9227 18.3214 17.7141 18.3239 17.4958C18.3265 17.2774 18.2434 17.0668 18.0925 16.909L14.9692 13.7856C15.997 12.5007 16.6163 10.8749 16.6163 9.10781C16.6163 4.97552 13.2486 1.60942 9.11629 1.60942ZM9.11629 3.27611C12.3478 3.27611 14.948 5.87628 14.948 9.10781C14.948 12.3393 12.3478 14.946 9.11629 14.946C5.88476 14.946 3.28459 12.3393 3.28459 9.10781C3.28459 5.87628 5.88476 3.27611 9.11629 3.27611Z",
    fill: "#3469E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlue);
export default __webpack_public_path__ + "static/media/SearchIconBlue.ba474f42e28e119c28c99e4e693e653c.svg";
export { ForwardRef as ReactComponent };